export default __webpack_public_path__ + "static/media/background-gift.244a9368.png";